"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGUID = void 0;
const uuid_1 = require("uuid");
function CreateGUID() {
    return uuid_1.v4();
}
exports.CreateGUID = CreateGUID;
//# sourceMappingURL=GUID.js.map